$(document).ready(function () {
    $('body').on('click', '.btnSearch', function (e) {
        e.preventDefault();
        $('.search-wrapper').toggle();
        return false;
    });

    $('body').on('click', '.search-wrapper button', function (e) {
        e.preventDefault();
        $('.search-wrapper').toggle();
        return false;
    });
});



const txts=document.querySelector(".animate-text").children,
               txtsLen=txts.length;
           let index=0;
          const textInTimer=3000,
                textOutTimer=2800;

         function animateText() {
            for(let i=0; i<txtsLen; i++){
              txts[i].classList.remove("text-in","text-out");
            }
            txts[index].classList.add("text-in");

            setTimeout(function(){
                txts[index].classList.add("text-out");
            },textOutTimer)

            setTimeout(function(){

              if(index == txtsLen-1){
                  index=0;
                }
               else{
                   index++;
                 }
                animateText();
            },textInTimer);
         }

       animateText();

// custom add to cart
$(".custom-add-to-cart-button").click(function () {
    let parentCartBox = jQuery(this).parents('.custom-cart-box');

    let productID = parentCartBox.find('.productID').val();

    let variantID = parentCartBox.find('.productVariantID').val();
    variantID = typeof variantID != 'undefined' ? variantID : productID;

    processCustomAddToCart(productID, variantID);
});

function processCustomAddToCart(productID, variantID) {
    jQuery.post('/cart/add.js', {quantity: 1, id: variantID}, null, "json").done(function () {
        let CartCount = jQuery('#CartCount').text();
        CartCount = parseFloat(CartCount) + 1;
        jQuery('#CartCount').text(CartCount);

        jQuery('.custom-add-to-cart-response-' + productID).addClass('success').html('<span>Added successfully.');

        setTimeout(function () {
            jQuery('.custom-add-to-cart-response-' + productID).removeClass('success').html('');
        }, 2000);
    })
        .fail(function ($xhr) {
            var data = $xhr.responseJSON;
            $('.custom-add-to-cart-response-' + productID).addClass('error').html('<span><b>ERROR: </b>' + data.description);
        });
}

// mobile menu
jQuery('body').on('click', '.mobileToggler', function () {
    jQuery(this).toggleClass('cross');
    jQuery('#menu').toggleClass('active');
});


// Responsive SideNavbar
const toggler = document.querySelector(".navbar > .toggler"),
    navListContainer = document.querySelector(
        ".navbar > .nav-list-container"
    );

/*when toggler button is clicked*/
toggler.addEventListener(
    "click",
    () => {
        //convert hamburger to close
        toggler.classList.toggle("cross");
        //make nav visible
        navListContainer.classList.toggle("nav-active");
    },
    true
);


// Promotion Click to Opne & Close
function toggleOpenClosePromotion() {
    var x = document.getElementById("promoDiv");
    if (x.style.display === "block") {
        x.style.display = "none";
    } else {
        x.style.display = "block";
    }
}

$(function () {
    $("#toggle").on('click', function () {
        $(".fa-chevron-down").toggleClass("down");
    });
});

/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');
        if (isNaN(number) || number == null) {
            return 0;
        }
        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';
        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }
    return formatString.replace(placeholderRegex, value);
};
// Insert any custom theme js here...
$(document).ready(function () {
    $('.product-form__quantity-selector').click(function (event) {
        event.stopPropagation();
        event.preventDefault();
    });
    $('.product-card-addtocart').click(function (event) {
        refreshCart();
        $(document).on('drawer_open_start', function () {
            $('.product-form>.btn').addClass('btn--primary');
            $('.product-form>.btn').removeClass('btn--secondary');
            $('.product-form>.btn').removeClass('btn--to-secondary-transitioned');
            $('.product-form>.btn .primary-text').show();
            $('.product-form>.btn .secondary-text').hide();
            $('.product-form>p').removeClass('product__notification--success')
            $('.product-form>.btn').removeClass("ajax-cart__toggle");
        });
        $('.cart-drawer__checkout').prop("disabled", false);
    });
});


const swiper = new Swiper('.swiper', {
        direction: 'horizontal',
        slidesPerView: 6,
        spaceBetween: 0,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
       breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 2,
                spaceBetween: 20
            },
            // when window width is >= 480px
            480: {
                slidesPerView: 3,
                spaceBetween: 30
            },
            // when window width is >= 640px
            640: {
                slidesPerView: 4,
                spaceBetween: 40
            },
            // when window width is >= 640px
            800: {
                slidesPerView: 6,
                spaceBetween: 0
            }
        }
  });





//Dropdown
let dropdownTitle1 = document.getElementById("dropdownTitle1");
let dropdownTitle4 = document.getElementById("dropdownTitle4");

if(dropdownTitle4){
    dropdownTitle4.addEventListener("click" ,() =>{
      dropdown("dropdown_items4" , "dropdown_overlay4" );
    })
}

if(dropdownTitle1){
  dropdownTitle1.addEventListener("click" ,() =>{
    dropdown("dropdown_items1" , "dropdown_overlay1" );
  })
}
let dropdownTitle2 = document.getElementById("dropdownTitle2");
let dropdownTitle5 = document.getElementById("dropdownTitle5");

if(dropdownTitle5){
    dropdownTitle5.addEventListener("click" ,() =>{
  
      dropdown("dropdown_items5" , "dropdown_overlay5" );
    })
  }

if(dropdownTitle2){
  dropdownTitle2.addEventListener("click" ,() =>{

    dropdown("dropdown_items2" , "dropdown_overlay2" );
  })
}
let dropdownTitle3 = document.getElementById("dropdownTitle3");
let dropdownTitle6 = document.getElementById("dropdownTitle6");

if(dropdownTitle6){
    dropdownTitle6.addEventListener("click" ,() =>{
      dropdown("dropdown_items6" , "dropdown_overlay6" );
    })
}


if(dropdownTitle3){
  dropdownTitle3.addEventListener("click" ,() =>{
    dropdown("dropdown_items3" , "dropdown_overlay3" );
  })
}

function dropdown(checkbox,overlay){


  // let checkBox = document.getElementById(checkbox);
  // checkBox.classList.toggle("dropdown_item_active");
  // removeDropdownClass(checkBox , overlay);
}
function removeDropdownClass(checkbox , overlay){

// let dropdownOverlay = document.getElementById(overlay);
// dropdownOverlay.addEventListener("click",()=>{
//   checkbox.classList.remove("dropdown_item_active");
// })
}

//Dropdown Age
let ageArea = document.querySelectorAll(".age_year_area li");
let clearType2 = document.querySelectorAll(".clear_type2");
for(let i of ageArea){
  i.addEventListener("click",()=>{
    i.classList.toggle("age_filter_active");
  })

}

//Dropdown Color
let colorArea = document.querySelectorAll(".color_items_area li");
for(let x of colorArea){
  x.addEventListener("click",()=>{
    x.classList.toggle("color_filter_active");
  })

}


$(window).scroll(function(e){ 
    var $el = $('.fixedElement'); 
    var isPositionFixed = ($el.css('position') == 'fixed');
    if ($(this).scrollTop() > 200 && !isPositionFixed){ 
      $el.css({'position': 'fixed', 'top': '0px'}); 
    }
    if ($(this).scrollTop() < 200 && isPositionFixed){
      $el.css({'position': 'static', 'top': '0px'}); 
    } 
});

function hideDiv() {
    var element = document.getElementById("hideContent");
    element.classList.add("hideTabContent");
}

let filter = $("#filter");
filter.on("click", function() {
    $(".hideTabContent").removeClass("hideTabContent");
})
let sortBy = $("#sortBy");
sortBy.on("click", function() {
    $(".hideTabContent").removeClass("hideTabContent");
})
